<ngb-progressbar [value]="progress"  height="4px"></ngb-progressbar>
